<div class="media-tab"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave()"
     (drop)="onDrop($event)">

  <input #fileInput type="file" multiple
         accept=".jpg,.jpeg,.png,.webp,.gif,.mp4,.webm,.mov"
         style="display:none"
         (change)="onFileSelected($event)">

  <div class="media-dropzone" [class.drag-active]="dragOver">
    <div class="dropzone-inner">
      <span class="dropzone-icon">&#8593;</span>
      <p class="dropzone-label">Drag &amp; drop files here, paste (Ctrl+V), or</p>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openFilePicker()">Browse Files</button>
      <p class="dropzone-hint">Images up to 50MB &bull; Videos up to 100MB &bull; JPG, PNG, WEBP, GIF, MP4, WEBM, MOV</p>
    </div>
  </div>

  <div *ngIf="queue.length > 0" class="upload-queue">
    <h6 class="section-label">Uploading</h6>
    <div class="media-grid">
      <div *ngFor="let item of queue; trackBy: trackById" class="media-cell upload-cell">
        <div class="media-thumb-wrap">
          <img *ngIf="item.mediaType === 'image'" [src]="item.localUrl" alt="" class="media-thumb">
          <video *ngIf="item.mediaType === 'video'" [src]="item.localUrl" class="media-thumb" muted preload="metadata"></video>
        </div>
        <div *ngIf="item.status === 'uploading' || item.status === 'pending'" class="progress-bar-wrap">
          <div class="progress-bar-fill" [style.width.%]="item.progressPct"></div>
        </div>
        <div *ngIf="item.status === 'error'" class="upload-error">
          <span class="error-msg">{{ item.error }}</span>
          <button type="button" class="btn btn-sm btn-warning retry-btn" (click)="retryUpload(item.id)">Retry</button>
        </div>
        <div *ngIf="item.status === 'done'" class="upload-done-badge">Done</div>
        <button type="button" class="delete-btn" (click)="removeQueueItem(item.id)" title="Remove">&#10005;</button>
        <div class="file-name">{{ item.file.name }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="mediaList.length > 0" class="saved-media">
    <h6 class="section-label">Media</h6>
    <div cdkDropList cdkDropListOrientation="horizontal" class="media-grid drag-list"
         (cdkDropListDropped)="onDrop2($event)">
      <div *ngFor="let item of mediaList; let i = index; trackBy: trackByUrl"
           cdkDrag class="media-cell saved-cell">
        <div class="media-thumb-wrap" cdkDragHandle>
          <img *ngIf="item.mediaType === 1" [src]="item.url" alt="" class="media-thumb">
          <video *ngIf="item.mediaType === 2" [src]="item.url" class="media-thumb" muted preload="metadata" controls></video>
        </div>
        <button type="button" class="delete-btn" (click)="removeMedia(i)" title="Remove">&#10005;</button>
        <div class="file-name">{{ item.fileName }}</div>
      </div>
    </div>
  </div>

</div>
